__turbopack_context__.v({
  "description": "_8YAiwG_description",
  "heroBanner": "_8YAiwG_heroBanner",
  "linkList": "_8YAiwG_linkList",
  "picture": "_8YAiwG_picture",
  "text": "_8YAiwG_text",
  "title": "_8YAiwG_title",
  "toolTip": "_8YAiwG_toolTip",
});
